import { usePopup } from "hooks/usePopup";
import { forwardRef, useState, useImperativeHandle } from "react";
import storageService from "services/storageService";
import { ConfirmationPopup } from "shared";

export const Component = ({ refresh }, ref) => {
  const { addPopup } = usePopup();
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({});

  const handleData = row => {
    setData(row);
    setIsOpen(true);
  };

  useImperativeHandle(ref, () => ({ handleData }));

  const handleClose = () => setIsOpen(false);

  const handleConfirm = async () => {
    try {
      await storageService.reviewCancellation(data.id, { status: "rejected" });
      addPopup({
        type: "success",
        title: "Cancelamento rejeitado com sucesso!"
      });
      refresh();
    } catch (err) {
      if (err?.response?.status !== 401) {
        const isAlreadyReviewed = err?.response?.status === 400;
        addPopup({
          type: "error",
          title: isAlreadyReviewed
            ? "Esta movimentação já foi revisada anteriormente."
            : "Erro ao rejeitar cancelamento"
        });
      }
    }
  };

  return (
    <ConfirmationPopup
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title="Rejeitar cancelamento"
      message="Deseja realmente rejeitar este cancelamento?"
      confirmText="Rejeitar"
      cancelText="Cancelar"
      localStorageKey="hideRejectionConfirmation"
      confirmButtonProps={{
        style: { backgroundColor: "#f44336", color: "#fff" }
      }}
    />
  );
};

export const Reject = forwardRef(Component);
